import React from 'react';
import {
  FormControl,
  FormLabel,
  Input,
  Select,
  Textarea,
  NumberInput,
  NumberInputField,
  useColorModeValue,
} from '@chakra-ui/react';
import {
  compactFormLabelProps,
  compactInputProps,
  compactSelectProps,
} from '../../theme/adminUi';

export function useAdminFormFieldProps() {
  const inputColor = useColorModeValue('black', 'gray.400');
  return {
    inputColor,
    labelProps: compactFormLabelProps,
    fieldProps: { ...compactInputProps, color: inputColor },
    selectProps: { ...compactSelectProps, color: inputColor },
    textareaProps: { ...compactInputProps, color: inputColor, size: 'sm' },
  };
}

export function AdminField({ label, children, isRequired, ...formControlProps }) {
  return (
    <FormControl isRequired={isRequired} {...formControlProps}>
      {label ? <FormLabel {...compactFormLabelProps}>{label}</FormLabel> : null}
      {children}
    </FormControl>
  );
}

export function AdminInput(props) {
  const { fieldProps } = useAdminFormFieldProps();
  return <Input {...fieldProps} {...props} />;
}

export function AdminSelect(props) {
  const { selectProps } = useAdminFormFieldProps();
  return <Select {...selectProps} {...props} />;
}

export function AdminTextarea(props) {
  const { textareaProps } = useAdminFormFieldProps();
  return <Textarea {...textareaProps} {...props} />;
}

export function AdminNumberInputField(props) {
  const { fieldProps } = useAdminFormFieldProps();
  return (
    <NumberInput size="sm">
      <NumberInputField {...fieldProps} {...props} />
    </NumberInput>
  );
}
